import {
  EnvironmentProviders,
  Type,
  makeEnvironmentProviders,
} from '@angular/core';
import { AbstractUseCaseCollection } from '@causality/core';

/**
 * Provides a collection of uses cases via angulars DI token.
 *
 * @param useCases Class that implements the use cases.
 * @param factory factory that creates the use cases class.
 *
 * @returns
 * Environment providers for angular.
 */
export function provideUseCaseCollection<T extends AbstractUseCaseCollection>(
  useCases: Type<T>,
  factory: () => T,
): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: useCases, useFactory: factory }]);
}
